import { useDispatch, useSelector } from 'react-redux';
import nls from '../../../../nls/pt-BR.json';
import {
  advanceToStep,
  studiesSelector,
} from '../../../../redux/studies.reducer';
import { SkipStepButton } from '../../components';
import { CalculateLayoutInstallmentsForm } from './calculateInstallmentsForm';

export const CalculateInstallmentsSecondary: React.FC = () => {
  const { layoutsValuationSecondaryResponse, currentStep } =
    useSelector(studiesSelector);

  const dispatch = useDispatch();

  const handleClickSkipStep = () => {
    dispatch(advanceToStep('qualifiedAudienceResponse'));
  };
  return (
    <>
      <p className="helper-text" style={{ margin: '16px 0px' }}>
        <span>
          {nls.studyCreationGuide.steps.step5.calculateInstallmentsHelper}{' '}
        </span>
        <span style={{ fontWeight: 700 }}>
          {nls.studyCreationGuide.steps.step5.secondaryMarket}:
        </span>
      </p>
      <SkipStepButton callback={handleClickSkipStep} />
      {layoutsValuationSecondaryResponse && (
        <CalculateLayoutInstallmentsForm
          data={layoutsValuationSecondaryResponse}
          currentStep={currentStep}
          marketType="secondary"
        />
      )}
    </>
  );
};
